import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Formulario from './pages/Formulario';
import Usuarios from './pages/Usuarios';
import Nowhere from './pages/Nowhere';
import Login from './pages/Login';
import Register from './pages/Register';
import Graficos from './pages/Graficos';
import Perfil from './components/Perfil';

const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
};

const ProtectedRoute = ({ element }) => {
    return isAuthenticated() ? element : <Navigate to="/" />;
};

function RoutesApp() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/home" element={<ProtectedRoute element={<Home />} />} />
            <Route path="/formulario" element={<ProtectedRoute element={<Formulario />} />} />
            <Route path="/usuarios" element={<ProtectedRoute element={<Usuarios />} />} />
            <Route path="/perfil" element={<ProtectedRoute element={<Perfil />} />} />
            <Route path="/graficos" element={<ProtectedRoute element={<Graficos />} />} />
            <Route path="*" element={<Nowhere />} />
        </Routes>
    );
}

export default RoutesApp;


